import request from "@/util/http";
import { BIZ_LANG } from "@/common/constant";
import { toBackendLanguage } from "@/util/language";

/** 非预览请求时附带当前用户语言，与后端 language_code（如 zh_CN）对齐 */
function withLanguageCode(params) {
  if (!params || params.previewPageId) return params || {};
  // 页头(4)/页尾(5)为全站全局槽位，不按当前浏览语言过滤（后端按通用语言回退）
  if (params.pageType === 4 || params.pageType === 5) return params;
  const bizLang = localStorage.getItem(BIZ_LANG);
  if (!bizLang) return params;
  return { ...params, languageCode: toBackendLanguage(bizLang) };
}

/** 获取已发布的装修配置（用户端，匿名可访问） */
export function getDecorationPage(params) {
  return request({ url: "/upms/shop/decoration/page", method: "get", params: withLanguageCode(params) });
}

/** 获取当前激活的主题（含 configurationJson 里的 token 配置）；匿名可访问 */
export function getActiveTheme() {
  return request({ url: "/upms/shop/decoration/theme", method: "get" });
}

/** 获取当前生效的全局弹窗广告（PC 端默认 terminalType=0） */
export function getActivePopups(params) {
  // PC 商城固定 terminalType=0，避免 params 覆盖默认值
  const merged = { ...(params || {}), terminalType: 0 };
  return request({ url: "/upms/shop/decoration/popup", method: "get", params: merged });
}

/** 获取启用的轮播图（PC 端默认 terminalType=0） */
export function listBanners(params) {
  const merged = Object.assign({ terminalType: 0 }, params || {});
  return request({ url: "/upms/shop/decoration/banner", method: "get", params: merged });
}

/** 获取当前生效的顶部轮番广告活动及其广告图（PC 端默认 terminalType=0） */
export function getActiveBannerCampaign(params) {
  const merged = Object.assign({ terminalType: 0 }, params || {});
  return request({ url: "/upms/shop/decoration/banner_campaign", method: "get", params: merged });
}
